import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chatbox-exit",
  "use": "chatbox-exit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"chatbox-exit\"><g data-name=\"icon - exit - 16px\"><path d=\"M-.001 0h16v16h-16z\" fill=\"none\" /><path data-name=\"↳color\" d=\"M9.049 8.132l5.253-5.253a.835.835 0 0 0-1.182-1.181L7.868 6.952 2.615 1.698a.835.835 0 0 0-1.181 1.181l5.255 5.253-5.255 5.253a.835.835 0 1 0 1.181 1.181l5.253-5.253 5.253 5.253a.835.835 0 0 0 1.181-1.181z\" fill=\"#031425\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol